<div class="content-wrapper">
    <div class="card">
        <div class="card-content has-text-centered">
            <p id="empty-list-info-text" class="has-font-200 color-grey-700 is-bold info-text">Momentan hast du keine <br/> Anzeigen online.</p>
            <a id="empty-list-button" [href]="url | stageUrl" (click)="tealiumLink()" class="btn btn--100 btn--primary">Neue Anzeige aufgeben</a>
        </div>
    </div>
</div>
